const stored = (() => {
  try {
    return localStorage.getItem("bannerfold-mode")
  } catch {
    return null
  }
})()

const systemMode = matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark"

document.documentElement.dataset.mode = ["light", "dark"].includes(stored) ? stored : systemMode
